import AccountDescriptions from './AccountDescriptions';

import { SECURED_CARD_STATUS } from 'utilities/constants';
import { formatDate } from 'utilities/datesAndTimes';
import { formatDollarsFromCents } from 'utilities/helpers';

const SecuredDescriptions = ({ account }) => {
  const items = [];
  const securedCardInfo = account?.securedCardInfo;

  if (securedCardInfo) {
    items.push({
      key: 1,
      span: 2,
      label: 'Current Secured Deposit Amount',
      children: (
        <span data-testid="current-secured-deposit-amount">
          {formatDollarsFromCents(securedCardInfo.currentAmount)}
        </span>
      ),
    });

    items.push({
      key: 2,
      span: 2,
      label: 'Original Secured Deposit Amount',
      children: (
        <span data-testid="original-secured-deposit-amount">
          {formatDollarsFromCents(securedCardInfo.originalAmount)}
        </span>
      ),
    });

    items.push({
      key: 3,
      span: 2,
      label: 'Security Deposit Status',
      children: (
        <span data-testid="security-deposit-status">
          {SECURED_CARD_STATUS[securedCardInfo.status]}
        </span>
      ),
    });

    items.push({
      key: 4,
      span: 2,
      label: 'Date of Security Deposit Change',
      children: (
        <span data-testid="date-of-security-deposit-change">
          {securedCardInfo.refundedDate
            ? formatDate(securedCardInfo.refundedDate)
            : 'N/A'}
        </span>
      ),
    });
  }

  return items.length ? (
    <AccountDescriptions title="Secured Details" items={items} />
  ) : undefined;
};

export default SecuredDescriptions;
